import { price } from './pre-order-form'
export default function(Site, $) {
  Site.widget('delivery-options', {
    _create() {
      this.inputs = this.element.find('input[type="radio"]')
      this.element.on('change', () => {
        this.update()
      })
      this.update()

      this.callables = []
    },
    change(fn) {
      this.callables.push(fn)
    },
    update() {
      this.inputs.get().find(element => {
        if (element.checked) {
          this.value = element.value
          return true
        }
      })
      Site.callAPI('woocommerce/set-delivery', {
        id: this.value,
      }).then(() => {
        this.callables.forEach(fn => fn())
        price.setState({
          min: this.value.indexOf('flat_rate') === 0 ? 80 : 100,
        })
      })
    },
  })
}
